<template>

    <v-step :step="step" title="Schedule">

        <v-form-group label="Schedule" caption="When to send the broadcast.">
            <v-select class="w-300" :model="schedule.is_scheduled" @input="setSchedule">
                <option :value="false">Send Immediately</option>
                <option :value="true">Schedule Delivery</option>
            </v-select>
        </v-form-group>

        <template v-if="schedule.is_scheduled">
            <v-form-group label="Date" caption="The day the broadcast will be sent.">
                <v-date-picker class="w-300" :unix="false" :model="schedule.date" @input="setParam({ date: $event })" />
            </v-form-group>
            <v-form-group label="Time" caption="The time the broadcast will be sent.">
                <v-time-picker :model="schedule.time" @input="setParam({ time: $event })" />
            </v-form-group>
            <v-form-group label="Time Zone" caption="The time zone to send in.">
                <v-timezone-picker class="w-300" :model="schedule.timezone || timezone" @input="setParam({ timezone: $event })" />
                <v-checkbox class="mt-15" label="Use customer time zone if available" :model="schedule.use_customer_timezone" @input="setParam({ use_customer_timezone: $event })" />
            </v-form-group>
        </template>

    </v-step>

</template>

<script>

import moment from 'moment';
import Step from '@pages/automations-edit/components/Step';

export default {

    components: {
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

        schedule() {
            return this.campaign.schedule || {};
        },

    },

    methods: {

        setSchedule(val) {
            this.setParam({ is_scheduled: val });
            if (val) {
                if (!this.schedule.date) {
                    this.setParam({ date: moment().format('YYYY-MM-DD') });
                }
                if (!this.schedule.time) {
                    this.setParam({ time: '12:00' });
                }
                if (!this.schedule.timezone) {
                    this.setParam({ timezone: moment.tz.guess() });
                }
            }
        },

        setParam(param) {
            let schedule = { ...this.schedule };
            let key = Object.keys(param)[0];
            schedule[key] = param[key];
            this.$store.commit('campaign/setParam', { schedule: schedule });
        },

    },

}

</script>
